import { render } from "./NavCatHeader.vue?vue&type=template&id=d6b844ba&scoped=true"
import script from "./NavCatHeader.vue?vue&type=script&lang=js"
export * from "./NavCatHeader.vue?vue&type=script&lang=js"

import "./NavCatHeader.vue?vue&type=style&index=0&id=d6b844ba&lang=scss&scoped=true"

import exportComponent from "D:\\QYYY\\mall_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6b844ba"]])

export default __exports__